<template>
  <div class="w100_ h100_ backfff" v-loading="loading">
      <div v-if="isShow" class="w100_ h100_ ">
          <iframe ref="iframeModel" :src="url" style="width: 100%; height: 100%" frameborder="0">
          </iframe>
      </div>
  </div>
</template>
<script lang="js">
import { statementDTO } from "@/DTO"; // 报表统计请求
import {analysisSysUrl} from '@/utils/const.js'
export default {
  data() {
      return {
          userCode: null,
          url:analysisSysUrl.ybStockTotal,
          isShow: false,
          loading: false,
      }
  },
  created() {
      this.getData()
  },
  methods: {
      async getData() {
          this.loading = true
          const res = await statementDTO.getReportTokenDTO(this.url)
          if (res.code == 200) {
              this.url = res.url
          }
          this.loading = false;
          this.isShow = true;
      }
  }
}
</script>